import { availabilityIcon, genetic } from 'src/js/mapper';
import { getFefoBruttoRetailPrice } from 'src/utils/fefoSelection';

function formatCannabinoidDisplay(equality, value) {
  const hasEquality = equality != null && equality !== '';
  const hasValue = value != null && value !== '';
  if (!hasEquality && !hasValue) return '';
  return `${hasEquality ? equality : ''}${hasValue ? value : ''}`;
}

export function getItemURL(inventory) {
  if (inventory.length === 0) {
    return null;
  } else {
    const length = inventory.length - 1;
    for (let i = 0; i <= length; i++) {
      if (inventory[i]['url'] != null && typeof inventory[i]['url'] != 'undefined') {
        return inventory[i]['url'];
      }
    }
  }
  return '';
}

export function getItemRemainingamount(inventory) {
  if (inventory.length === 0) {
    return 0;
  } else {
    const length = inventory.length - 1;
    let remaining_amount = 0.0;
    for (let i = 0; i <= length; i++) {
      if (inventory[i]['remaining_amount'] != null && typeof inventory[i]['remaining_amount'] != 'undefined') {
        remaining_amount += inventory[i]['remaining_amount'];
      }
    }
    return remaining_amount;
  }
}

export function getItemVirtualRemainingAmount(inventory) {
  if (inventory.length === 0) {
    return 0;
  } else {
    const length = inventory.length - 1;
    let virtual_remaining_amount = 0.0;
    for (let i = 0; i <= length; i++) {
      if (inventory[i]['virtual_remaining_amount'] != null && typeof inventory[i]['virtual_remaining_amount'] != 'undefined') {
        virtual_remaining_amount += inventory[i]['virtual_remaining_amount'];
      }
    }
    return virtual_remaining_amount  + inventory[0]['wholesaler_remaining_amount'];
  }
}

export function getItemAvailability(inventory) {
  if (inventory.length === 0) {
    return false;
  } else {
    const length = inventory.length - 1;
    for (let i = 0; i <= length; i++) {
      if (inventory[i]['availability'] != null && typeof inventory[i]['availability'] != 'undefined') {
        if (inventory[i]['availability'] == true) {
          return true;
        }
      }
    }
    return false;
  }
}

export function getItemBruttoRetailPrice(inventory) {
  if (inventory.length === 0) {
    return 0;
  } else {

    let price = 0.0;

    const length = inventory.length - 1;
    for (let i = 0; i <= length; i++) {
      if (
        inventory[i]['brutto_retail_price'] != null &&
        typeof inventory[i]['brutto_retail_price'] != 'undefined' &&
        inventory[i]['availability'] === true
      ) {
        if(price !== 0.0 && inventory[i]['brutto_retail_price'] < price){
          price = inventory[i]['brutto_retail_price'];
        }else if(price === 0.0){
          price = inventory[i]['brutto_retail_price'];
        }
      }
    }
    return price;
  }
}

export function getItemInventoryID(inventory) {
  if (inventory.length === 0) {
    return false;
  } else {
    const length = inventory.length - 1;
    for (let i = 0; i <= length; i++) {
      if (inventory[i]['id'] != null && typeof inventory[i]['id'] != 'undefined') {
        return inventory[i]['id'];
      }
    }
    return false;
  }
}

export function searchItems(items, search) {
  const needle = `${search.term}`.toLowerCase();
  const key = search.option.value;

  if (key == null || typeof key == 'undefined' || needle == null || typeof needle == 'undefined') {
    return items;
  }

  if (needle !== '') {
    const out = [];
    const length = items.length - 1;

    for (let i = 0; i <= length; i++) {
      if (items[i].search && items[i].search[key] && items[i].search[key].includes(needle)) {
        out[out.length] = items[i];
      }
    }

    return out;
  }

  return items;
}

export function getTypeFromInventory(inventory) {
  const length = inventory.length - 1;
  for (let i = 0; i <= length; i++) {
    if (inventory[i].type != null) {
      return inventory[i].type;
    }
  }
  return null;
}
export function getUnitFromInventory(inventory) {
  const length = inventory.length - 1;
  for (let i = 0; i <= length; i++) {
    if (inventory[i].packaging_unit != null) {
      return inventory[i].packaging_unit;
    }
  }
  return null;
}

/** Display label for product/packaging units (API may store "stuck"). */
export function formatProductUnitLabel(unit) {
  if (unit == null || unit === '') return '';
  const normalized = String(unit).trim().toLowerCase();
  if (
    normalized === 'stück'
    || normalized === 'stuck'
    || normalized === 'stk'
    || normalized === 'stk.'
    || normalized === 'st'
  ) {
    return 'Stück';
  }
  return String(unit);
}

export function mapArticleInventory(item) {
  const itemUrl = getItemURL(item.inventory);
  const itemAvailability = getItemAvailability(item.inventory);
  const itemRemainingamount = getItemRemainingamount(item.inventory);
  const itemVirtualRemainingAmount = getItemVirtualRemainingAmount(item.inventory)
  const itemPrice = getItemBruttoRetailPrice(item.inventory);
  const totalVirtualRemainingAmount = item.inventory.reduce((acc, curr) => acc + curr.virtual_remaining_amount, 0);

  item.mapped = {
    inventory: [],
    item: {
      availability: itemAvailability,
      availabilityIcon: availabilityIcon(itemAvailability),
      remaining_amount: itemRemainingamount > 0 ? itemRemainingamount : '',
      virtual_remaining_amount: itemVirtualRemainingAmount,
      total_virtual_remaining_amount: totalVirtualRemainingAmount,
      price: itemPrice,
      thc: formatCannabinoidDisplay(item.item.equality_thc, item.item.thc),
      cbd: formatCannabinoidDisplay(item.item.equality_cbd, item.item.cbd),
      manufacturer: item.item.manufacturer != null ? `${item.item.manufacturer.name}` : '',
      cultivar: item.item.cultivar != null ? item.item.cultivar : '',
      genetic: genetic(item.item.genetic),
      url: itemUrl === null ? '' : itemUrl
    }
  };

  if (item.item.name !== null) {
    item.search = {
      all: `${item.item.name.toLowerCase()}${item.mapped.item.manufacturer.toLowerCase()}${item.mapped.item.cultivar.toLowerCase()}${item.mapped.item.cultivar.toLowerCase()}${item.mapped.item.genetic.toLowerCase()}`
    };
  }

  return item;
}

export function mapThirdCategoryArticleInventory(item) {
  const normalized = {
    ...item,
    item: {
      ...item.item,
      name: item.item.product_name || item.item.name,
      manufacturer: item.item.brand ? { name: item.item.brand } : item.item.manufacturer,
    },
    inventory: (item.inventory || []).map((inv) => ({
      ...inv,
      type: inv.type || 'other',
    })),
  };

  const mapped = mapArticleInventory(normalized);
  const fefoPrice = getFefoBruttoRetailPrice(normalized.inventory);

  if (fefoPrice) {
    mapped.mapped.item.price = fefoPrice;
  }

  return mapped;
}

function findSubstringInArray(substring, array) {
  let result = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i].includes(substring)) {
      return true;
    }
  }
  return false;
}
